import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Seq } from 'immutable';

import { ModalActions } from '../../actions/modal';
import { PROJROLE_ADMIN, ROLE_NAME } from '../../shared/constants';
import RoleDropdown from './RoleDropdown';
import Avatar from '../Avatar';

export default class UsersFieldArray extends Component {
  static propTypes = {
    usersMap: PropTypes.instanceOf(Seq).isRequired,
    fields: PropTypes.object.isRequired,
    formObjectId: PropTypes.string,
    user: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    removeUserCallback: PropTypes.func,
    changeUserRoleCallback: PropTypes.func,
    role: PropTypes.number,
    adminUserOnly: PropTypes.bool,
  };

  removeUser = (userId, index) => {
    const {
      fields: {
        remove,
      },
      formObjectId,
      removeUserCallback,
    } = this.props;

    removeUserCallback(formObjectId, userId);
    remove(index);
  }

  confirmDelete = (userId, index) => {
    const {
      dispatch,
    } = this.props;

    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'projectUser',
        handleDelete: ::this.removeUser.bind(this, userId, index),
        confirmText: 'Remove',
      },
    }));
  };

  render() {
    const {
      usersMap,
      fields: {
        map,
      },
      formObjectId,
      user,
      changeUserRoleCallback,
      role,
      adminUserOnly,
    } = this.props;

    return (<tbody className="project-users-table-body">
      {
        map((userFieldName, userIndex) => {
          // console.log(userIndex, userFieldName, `${userFieldName}.role`,
          //             typeof userFieldName, eval(`${userFieldName}`));
          const currentUser = usersMap.get(userIndex);
          const firstName = currentUser.getIn(['first_name']);
          const lastName = currentUser.getIn(['last_name']);
          // const company = currentUser.getIn(['company']);

          const userFirstName = firstName || '';
          const userLastName = lastName || '';

          const userName = (userFirstName || userLastName)
            ? `${userFirstName} ${userLastName}`
            : currentUser.getIn(['display_name']);

          const userEmail = currentUser.getIn(['email']);
          const userId = currentUser.getIn(['id']);

          let userRoleId = currentUser.getIn(['role']);
          if (userRoleId < PROJROLE_ADMIN) userRoleId = PROJROLE_ADMIN; // Do not display super user
          if (adminUserOnly && (userRoleId !== PROJROLE_ADMIN)) return null;

          const createdBy = (userId === user.get('id'));
          const deleteButton = ((role <= PROJROLE_ADMIN) && !createdBy) ? <td>
              <button
                type="button"
                onClick={
                  () => this.confirmDelete(userId, userIndex)
                }
                className="action-btn btn btn-danger btn-xs"
              >
                <i className="fa fa-times" />
              </button>
            </td> : <td></td>;

          const roleSelect = ((role <= PROJROLE_ADMIN) && !createdBy && !adminUserOnly) ? (<Field
            name={`${userFieldName}.role`}
            component={RoleDropdown}
            type="select"
            userId={userId}
            changeUserRoleCallback={changeUserRoleCallback}
            formObjectId={formObjectId}
          />) : ROLE_NAME[userRoleId];

          return (
            <tr key={userId}>
              <td>
                <Avatar
                  className="mr-1"
                  user={usersMap.get(userIndex)}
                  width="37"
                  height="37"
                  rounded
                />
                {userName}
              </td>
              <td>{userEmail}</td>
              {/* <td>{company}</td> */}
              <td className="roles-dropdown-container">{roleSelect}</td>
              <td>No</td>
              {deleteButton}
            </tr>
          );
        })
      }
    </tbody>);
  }
}



// WEBPACK FOOTER //
// ./src/components/form/UsersFieldArray.js